import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/base.service';
import { RegisteredDrone } from './registered-drone.model';

@Injectable({
    providedIn: 'root'
})

export class DroneService extends BaseService {

    private updateStringifyInclude = ["remote_id"];

    public getDrones(idToken: string, searchParams: any, pageSize: number, pageIndex: number) {
        let queryParams = new HttpParams();
        queryParams = this.appendQueryParam(queryParams, "dealer-id", searchParams.dealerId);
        queryParams = this.appendQueryParam(queryParams, "customer-id", searchParams.customerId);
        queryParams = this.appendQueryParam(queryParams, "serial-number", searchParams.serialNumber);
        queryParams = this.appendQueryParam(queryParams, "remote-id", searchParams.remoteId);
        queryParams = this.appendQueryParam(queryParams, "model", searchParams.model);
        queryParams = this.appendQueryParam(queryParams, "per-page", pageSize);
        queryParams = this.appendQueryParam(queryParams, "page", pageIndex + 1);

        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/drones`, { headers, params: queryParams });
    }

    public getDrone(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/drone/${id}`, { headers });
    }

    public addDrone(idToken: string, model: string, manufactureDate: string) {
        const body = {
            "model": model,
            "manufacture_date": manufactureDate
        };
        const headers = this.getHeaders(idToken);
        return this.httpClient.post(`${this.backendDomain}/drone`, body, { headers });
    }

    public updateDrone(idToken: string, drone: RegisteredDrone) {
        const body = JSON.stringify(drone, this.updateStringifyInclude);
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/drone/${drone.id}`, body, { headers });
    }

    public transferDrone(idToken: string, id: number,
        transferToType: number, transferToId: number, transferDate: string) {
        const body = {
            "transfer_to_type": transferToType, "transfer_to_id": transferToId,
            "transfer_date": transferDate
        };
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/drone/transfer/${id}`, body, { headers });
    }

    public deleteDrone(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.delete(`${this.backendDomain}/drone/${id}`, { headers });
    }

    public getModels(idToken: string) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/drone-models`, { headers });
    }
}